import React, {Fragment} from 'react'
import {useParams} from 'react-router-dom'
import {pluralise} from 'admin/lib/format'
import {isEmpty} from 'lodash'
import useDocument from 'admin/hooks/useDocument'
import useOrganisation from 'admin/hooks/useOrganisation'
import Table from './Table'
import FourZeroFour from 'admin/components/FourZeroFour'
import Page from 'admin/components/shared/Page'
import useServices from '../../hooks/useServices'
import InputField from 'admin/components/shared/InputField'
import Pagination from 'admin/components/shared/Pagination'
import Sorting from '../shared/Sorting'
import useModal from '../../hooks/useModal'

const sortOptions = [
  {sortBy: 'name', sortDirection: 'asc', sortLabel: 'Account name', ascLabel: 'A-Z', descLabel: 'Z-A'},
  {sortBy: 'internet_service_plans.name', sortDirection: 'asc', sortLabel: 'Plan', ascLabel: 'A-Z', descLabel: 'Z-A'},
  {sortBy: 'address', sortDirection: 'asc', sortLabel: 'Location', ascLabel: 'A-Z', descLabel: 'Z-A'},
  {sortBy: 'description', sortDirection: 'asc', sortLabel: 'Description', ascLabel: 'A-Z', descLabel: 'Z-A'}
]

export default () => {
  const {organisationID, status} = useParams()
  const {pushModal} = useModal()
  const {services, totalCount, filters, setFilters} = useServices(organisationID, undefined, status)
  const {organisation} = useOrganisation(organisationID)

  useDocument({title: 'Services'})

  const handleSearch = changes => {
    setFilters({...changes, page: 1})
  }

  if (isEmpty(organisation)) return <Page />
  if (!organisation.featureFlags.includes('internet_services')) return <FourZeroFour />

  return (
    <Page
      title={`Manage ${status} services`}
      subtitle={
        totalCount
          ? `Showing ${services.length} of ${pluralise(`${status} service`, totalCount, true)}`
          : `No ${status} services found`
      }>
      <form className='box is-radiusless is-shadowless has-background-filters'>
        <div className='field is-grouped'>
          <div className='control is-expanded'>
            <InputField
              type='search'
              name='q'
              label='Search'
              autoComplete='off'
              value={filters.q}
              debounce={true}
              onChange={handleSearch}
            />
          </div>
        </div>
      </form>

      {services.length != 0 ? (
        <Fragment>
          <div className='level'>
            <div className='level-left'>
              <Sorting
                className='level-item'
                sortOptions={sortOptions}
                sortBy={filters.sortBy}
                sortDirection={filters.sortDirection}
                onChange={setFilters}
              />
            </div>
            <div className='level-right'>
              <Pagination
                page={filters.page}
                limit={filters.limit}
                total={totalCount}
                onChange={setFilters}
                className='level-item'
              />
            </div>
          </div>

          <Table
            data={services}
            organisationID={organisationID}
            onClick={id => pushModal('service', {serviceId: id})}
          />

          {services.length >= 10 && (
            <div className='level'>
              <div className='level-left'></div>
              <div className='level-right'>
                <Pagination
                  page={filters.page}
                  limit={filters.limit}
                  total={totalCount}
                  onChange={setFilters}
                  className='level-item'
                />
              </div>
            </div>
          )}
        </Fragment>
      ) : null}
    </Page>
  )
}
